<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M10,3C9.08,3,8.24,3.26,7.5,3.69C6.76,3.26,5.92,3,5,3C2.24,3,0,5.24,0,8C0,10.76,2.24,13,5,13C5.92,13,6.76,12.74,7.5,12.31C8.24,12.74,9.08,13,10,13C12.76,13,15,10.76,15,8C15,5.24,12.76,3,10,3C10,3,10,3,10,3ZM5.9,10.85C5.61,10.940000000000001,5.31,11,5,11C3.34,11,2,9.66,2,8C2,6.34,3.34,5,5,5C5.31,5,5.61,5.0600000000000005,5.9,5.15C5.33,5.96,5,6.9399999999999995,5,8C5,9.059999999999999,5.33,10.04,5.9,10.85C5.9,10.85,5.9,10.85,5.9,10.85ZM10,11C9.69,11,9.39,10.940000000000001,9.1,10.85C9.67,10.04,10,9.059999999999999,10,8C10,6.9399999999999995,9.67,5.96,9.1,5.15C9.39,5.0600000000000005,9.69,5,10,5C11.66,5,13,6.34,13,8C13,9.66,11.66,11,10,11C10,11,10,11,10,11Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Intersection',
} as DefineComponent
</script>
